import {
	ABOUT,
	ABOUT_HOW_PAY_BY_MALL_PAY,
	ABOUT_INVESTMENTS,
	ABOUT_MALL_PAY,
	ABOUT_PAY_IN_THREE,
	ABOUT_REWARDS,
	ABOUT_TRANSACTION_PAYMENT,
	CARD,
	CAREER,
	CONTACTS,
	DEFERRED_BILLING,
	FOR_JOURNALISTS,
	INSURANCE_TO_CARD,
	MOBILE_APP,
	PUBLIC_SUPPORT,
	URL_BLOG,
	URL_BLOG_PODCAST,
} from 'constants/routes';

import React from 'react';


import { ReactComponent as IconApp } from '@skippay/core/assets/icons/servicesMenu/app.svg';
import { ReactComponent as IconCard } from '@skippay/core/assets/icons/servicesMenu/card.svg';
import { ReactComponent as IconDeferredBilling } from '@skippay/core/assets/icons/servicesMenu/deferred-billing.svg';
import { ReactComponent as IconHowPay } from '@skippay/core/assets/icons/servicesMenu/how-pay.svg';
import { ReactComponent as IconInvestment } from '@skippay/core/assets/icons/servicesMenu/investment.svg';
import { ReactComponent as IconPayInThree } from '@skippay/core/assets/icons/servicesMenu/pay-in-three.svg';
import { ReactComponent as IconPayment } from '@skippay/core/assets/icons/servicesMenu/payment.svg';
import { ReactComponent as IconRewards } from '@skippay/core/assets/icons/servicesMenu/rewards.svg';
import { ReactComponent as IconBrand } from '@skippay/core/assets/icons/servicesMenu/skippay.svg';
import { ReactComponent as IconWaranty } from '@skippay/core/assets/icons/servicesMenu/waranty.svg';
import { FormattedMessage } from '@skippay/core/i18n/intl';
import { MENU_MAIN_WEB_PREFIX, getAnalyticsName } from '@skippay/core/utils/analyticsUtils';

type RouteLink =
	| typeof ABOUT
	| typeof ABOUT_HOW_PAY_BY_MALL_PAY
	| typeof ABOUT_INVESTMENTS
	| typeof ABOUT_MALL_PAY
	| typeof ABOUT_REWARDS
	| typeof ABOUT_TRANSACTION_PAYMENT
	| typeof CARD
	| typeof CAREER
	| typeof DEFERRED_BILLING
	| typeof FOR_JOURNALISTS
	| typeof INSURANCE_TO_CARD
	| typeof MOBILE_APP
	| typeof PUBLIC_SUPPORT
	| typeof URL_BLOG;

type Link = {
	testId: string;
	title: JSX.Element;
	to: RouteLink;
	analyticsParam: string;
	icon?: JSX.Element;
	description?: JSX.Element;
	image?: JSX.Element;
};

function useLinks(): {
	dropdownLinksAboutUs: Link[];
	dropdownLinksServices: Link[];
} {
	const dropdownLinksAboutUs = [
		{
			testId: 'about',
			title: (
				<FormattedMessage id="PublicNavbar.aboutSkipPay" defaultMessage="Představení Skip Pay" />
			),
			to: ABOUT as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT, MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'faq',
			title: <FormattedMessage id="PublicNavbar.faq" defaultMessage="Často kladené otázky" />,
			to: PUBLIC_SUPPORT as RouteLink,
			analyticsParam: getAnalyticsName(PUBLIC_SUPPORT, MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'career',
			title: <FormattedMessage id="PublicNavbar.career" defaultMessage="Kariéra" />,
			to: CAREER as RouteLink,
			analyticsParam: getAnalyticsName(CAREER, MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'blog',
			title: <FormattedMessage id="PublicNavbar.blog" defaultMessage="Blog" />,
			to: URL_BLOG as RouteLink,
			analyticsParam: getAnalyticsName('blog', MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'podcast',
			title: <FormattedMessage id="PublicNavbar.podcast" defaultMessage="Podcast" />,
			to: URL_BLOG_PODCAST as RouteLink,
			analyticsParam: getAnalyticsName('podcast', MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'forJournalists',
			title: <FormattedMessage id="PublicNavbar.forMedia" defaultMessage="Pro novináře" />,
			to: FOR_JOURNALISTS as RouteLink,
			analyticsParam: getAnalyticsName(FOR_JOURNALISTS, MENU_MAIN_WEB_PREFIX),
		},
		{
			testId: 'forJournalists',
			title: <FormattedMessage id="PublicNavbar.contacts" defaultMessage="Kontakty" />,
			to: CONTACTS as RouteLink,
			analyticsParam: getAnalyticsName(CONTACTS, MENU_MAIN_WEB_PREFIX),
		},
	];

	const dropdownLinksServices = [
		{
			testId: 'aboutSkipPay',
			title: (
				<FormattedMessage
					id="PublicNavbar.skipPayPayment"
					defaultMessage="Odložená platba Skip Pay"
				/>
			),
			to: ABOUT_MALL_PAY as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_MALL_PAY, MENU_MAIN_WEB_PREFIX),
			icon: <IconBrand />,
			description: (
				<FormattedMessage
					id="PublicNavbar.skipPayPayment.description"
					defaultMessage="Pořiďte si hned, po čem vaše srdce touží. Vše si doma nejdřív v klidu prohlédnete a co vám sedne, zaplatíte chytře až za 50 dní."
				/>
			),
			
		},
		{
			testId: 'card',
			title: <FormattedMessage id="PublicNavbar.card" defaultMessage="Skip Pay karta" />,
			to: CARD as RouteLink,
			analyticsParam: getAnalyticsName(CARD, MENU_MAIN_WEB_PREFIX),
			icon: <IconCard />,
			description: (
				<FormattedMessage
					id="PublicNavbar.card.description"
					defaultMessage="S naší nejférovější kartou platíte chytře úplně všude. V prodejnách i na e-shopech."
				/>
			),
			
		},
		{
			testId: 'aboutPayInThree',
			title: (
				<FormattedMessage id="PublicNavbar.aboutPayInThree" defaultMessage="Nákup na Třetinu" />
			),
			to: ABOUT_PAY_IN_THREE as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_PAY_IN_THREE, MENU_MAIN_WEB_PREFIX),
			icon: <IconPayInThree />,
			description: (
				<FormattedMessage
					id="PublicNavbar.mobileApp.aboutPayInThree"
					defaultMessage="Čekají vás větší výdaje? S námi můžete za zboží zaplatit jen třetinu ceny a zbytek doplatíte později ve dvou splátkách. Bez navýšení a bez poplatků."
				/>
			),
			
		},
		{
			testId: 'mobileApp',
			title: <FormattedMessage id="PublicNavbar.mobileApp" defaultMessage="Mobilní aplikace" />,
			to: MOBILE_APP as RouteLink,
			analyticsParam: getAnalyticsName(MOBILE_APP, MENU_MAIN_WEB_PREFIX),
			icon: <IconApp />,
			description: (
				<FormattedMessage
					id="PublicNavbar.mobileApp.description"
					defaultMessage="Potvrzujte nákupy rychlostí blesku, zobrazte si údaje vaší karty, dostávejte exkluzivní nabídky. S naší apkou vám nic neunikne"
				/>
			),
			
		},
		{
			testId: 'aboutTransactionPayment',
			title: (
				<FormattedMessage id="PublicNavbar.transactionPayment" defaultMessage="Převod peněz" />
			),
			to: ABOUT_TRANSACTION_PAYMENT as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_TRANSACTION_PAYMENT, MENU_MAIN_WEB_PREFIX),
			icon: <IconPayment />,
			description: (
				<FormattedMessage
					id="PublicNavbar.transactionPayment.description"
					defaultMessage="Posílejte peníze rychle, bezpečně a bez poplatků na jakýkoli český účet. S námi vyřešíte faktury, nájem i složenky, a ještě vás za to odměníme."
				/>
			),
			
		},
		{
			testId: 'aboutRewards',
			title: <FormattedMessage id="PublicNavbar.rewards" defaultMessage="Odměny za nákupy" />,
			to: ABOUT_REWARDS as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_REWARDS, MENU_MAIN_WEB_PREFIX),
			icon: <IconRewards />,
			description: (
				<FormattedMessage
					id="PublicNavbar.rewards.description"
					defaultMessage="Za každou zaplacenou stokorunu vás odměníme. Získané body vyměníte za slevy do oblíbených obchodů nebo dopravu zdarma."
				/>
			),
			
		},
		{
			testId: 'deferredBilling',
			title: (
				<FormattedMessage id="PublicNavbar.deferredBilling" defaultMessage="Posunutí splatnosti" />
			),
			to: DEFERRED_BILLING as RouteLink,
			analyticsParam: getAnalyticsName(DEFERRED_BILLING, MENU_MAIN_WEB_PREFIX),
			icon: <IconDeferredBilling />,
			description: (
				<FormattedMessage
					id="PublicNavbar.deferredBilling.description"
					defaultMessage="Plaťte jen tolik, kolik se vám zrovna hodí. S námi stačí zaplatit jen desetinu měsíční útraty a zbytek později. Jedním kliknutím za pár korun."
				/>
			),
			
		},
		{
			testId: 'aboutInvestment',
			title: <FormattedMessage id="PublicNavbar.aboutInvestment" defaultMessage="Investice" />,
			to: ABOUT_INVESTMENTS as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_INVESTMENTS, MENU_MAIN_WEB_PREFIX),
			icon: <IconInvestment />,
			description: (
				<FormattedMessage
					id="PublicNavbar.aboutInvestment.description"
					defaultMessage="Přihoďte si pár korun ke každému nákupu se Skip Pay a nechte je za sebe chytře investovat. Bez  práce a počítání."
				/>
			),
			
		},
		{
			testId: 'howToPayByMallPay',
			title: <FormattedMessage id="PublicNavbar.howToPayByMallPay" defaultMessage="Jak zaplatit" />,
			to: ABOUT_HOW_PAY_BY_MALL_PAY as RouteLink,
			analyticsParam: getAnalyticsName(ABOUT_HOW_PAY_BY_MALL_PAY, MENU_MAIN_WEB_PREFIX),
			icon: <IconHowPay />,
			description: (
				<FormattedMessage
					id="PublicNavbar.howToPayByMallPay.description"
					defaultMessage="Až přijde čas, své nákupy se Skip Pay snadno uhradíte online kartou, bankovním převodem nebo pomocí QR kódu. V apce nebo Zákaznické zóně."
				/>
			),
			
		},
	];

	return {
		dropdownLinksAboutUs,
		dropdownLinksServices,
	};
}

export default useLinks;
